import {
  DEFAULT_CURRENCY_FORMAT,
  DEFAULT_CURRENCY_PLACEHOLDER,
} from '../../../../constants';
import { formatValue } from '../../../../utils/managerUtils';
import { AggregateControlAction } from '../../../../types/types';
import {
  AggregateResultItem,
  AggregateResultValue,
  FormattedAggregateRow,
} from '../types';

// Formats aggregate result items exactly like the dataset grid by reusing
// formatValue with a synthetic float column; %m is resolved to the currency
// format first since sprintf cannot interpret it. Multi-value items are
// flattened to one row per value so the label cell can rowspan over them.
export const getFormattedAggregateRows = (
  items: AggregateResultItem[],
  currencyFormat?: string | null,
  numberFormat?: string | null,
  aggregateItems?: AggregateControlAction['items']
): FormattedAggregateRow[] => {
  const resolvedCurrencyFormat = currencyFormat || DEFAULT_CURRENCY_FORMAT;
  // The response carries no operation, so it is looked up by the label it shares
  // with the control definition.
  const operationByLabel = new Map(
    (aggregateItems ?? []).map(({ label, operation }) => [label, operation])
  );

  return items.flatMap((item) => {
    const entries: AggregateResultValue[] = item.values ?? [
      { value: item.value ?? null, format: item.format },
    ];
    return entries.map((entry) => {
      // count is an integer; a non-numeric min/max (date, text) would break sprintf
      const fallbackFormat =
        numberFormat &&
        typeof entry.value === 'number' &&
        operationByLabel.get(item.label) !== 'count'
          ? numberFormat
          : undefined;
      const resolvedFormat =
        entry.format?.replaceAll(
          DEFAULT_CURRENCY_PLACEHOLDER,
          resolvedCurrencyFormat
        ) ?? fallbackFormat;
      const column = {
        name: 'value',
        type: resolvedFormat ? 'float' : undefined,
        format: resolvedFormat,
      };
      return {
        label: item.label,
        valueLabel: entry.label,
        value: String(formatValue(entry, column)),
      };
    });
  });
};
